module.exports = __webpack_public_path__ + "../public/img/loading.cddce16e.svg";